<template>
    <BCol cols="12" :md="vsMd">
        <ValidationProvider #default="validationContext" :rules="vsRules">
            <BFormGroup :label-for="vsName.toLowerCase()" :class="vsRequired == '' ? 'required-field' : ''">
                <BFormCheckbox :id="vsName.toLowerCase()" :checked="vsModel" @change="$emit('update:vsModel', !vsModel)"> {{ $t(vsLabel) }} </BFormCheckbox>
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { BCol, BFormCheckbox, BFormGroup, BFormInvalidFeedback } from 'bootstrap-vue';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormInvalidFeedback, BFormCheckbox },
    props: ['vsName', 'vsModel', 'vsMd', 'vsRules', 'vsRequired', 'vsLabel'],
    emit: ['update:vsModel'],
    setup() {
        const { getValidationState } = formValidation()

        return {
            getValidationState
        }
    },
}
</script>